import { render, staticRenderFns } from "./PopUpLayout.vue?vue&type=template&id=2d9d4e48&scoped=true&"
import script from "./PopUpLayout.vue?vue&type=script&lang=js&"
export * from "./PopUpLayout.vue?vue&type=script&lang=js&"
import style0 from "./PopUpLayout.vue?vue&type=style&index=0&id=2d9d4e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d4e48",
  null
  
)

export default component.exports